import React from 'react';
import Panel from '../../layout/Panel';
import { PlayCircle as LiveTrialIcon } from '@mui/icons-material';
import LiveTrialCore from './LiveTrialCore';

export default function LiveTrial() {
  return (
    <Panel 
      title="Live Trial Streaming"
      icon={<LiveTrialIcon />}
      contentSx={{ p: 0 }}
    >
      <LiveTrialCore />
    </Panel>
  );
}